// extracted by mini-css-extract-plugin
module.exports = {"tabbedView":"quotePagePanel_tabbedView__sk_RB","viewArea":"quotePagePanel_viewArea__ewM3J"};